import { useState } from "react";

import Typography from "../Typography/Typography";
import styles from "./Switch.module.scss";

const Switch = (props) => {
	const {
		className,
		label = "",
		onChange,
		value = false,
		aligment = "right",
	} = props;

	const [isChecked, setIsChecked] = useState(value);

	const toggleSwitch = () => {
		setIsChecked((prev) => !prev);
		onChange(!isChecked);
	};

	return (
		<div
			className={`${styles.switchContainer} ${className}`}
			onClick={toggleSwitch}
		>
			{aligment === "left" && (
				<Typography variant="h7">{label}</Typography>
			)}
			<div className={styles.switchTrack}>
				<div
					className={`${styles.switchThumb} ${
						isChecked ? styles.switchThumbChecked : null
					}`}
				/>
			</div>
			{aligment === "right" && (
				<Typography variant="h7">{label}</Typography>
			)}
		</div>
	);
};

export default Switch;
